export default __webpack_public_path__ + "static/media/forth_slogan.dc691444.png";